import { useEffect, useState } from "react";
import { draftThumbnailBlob } from "./mediaApi";
export default function ThumbnailPicker({ file, onChange, scope, savedDraft, disabled }) {
  const [url, setUrl] = useState(""), [error, setError] = useState("");
  useEffect(() => {
    let active = true, objectUrl;
    setUrl(""); setError("");
    async function preview() {
      if (!file && !savedDraft?.hasThumbnail) return;
      try {
        const blob = file || await draftThumbnailBlob(scope, savedDraft.id);
        if (!active || !URL.createObjectURL) return;
        objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
      } catch { if (active) setError("The saved thumbnail preview could not be loaded."); }
    }
    preview();
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [file, scope, savedDraft?.id, savedDraft?.hasThumbnail]);
  return <div className="mediaThumbnailPicker"><label>Thumbnail image<input key={savedDraft?.id || "new"} type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" disabled={disabled} onChange={event => onChange(event.target.files[0] || null)} /></label><p className="mediaHint">Optional. JPG or PNG, up to 2 MB. A wide 16:9 image works best. {savedDraft?.hasThumbnail && !file ? `Saved: ${savedDraft.thumbnail_name}. Select an image to replace it.` : ""}</p>{url && <img className="mediaThumbnailPreview" src={url} alt="Selected video thumbnail preview" />}{error && <p role="status">{error}</p>}</div>;
}
